var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4165 28.75V25.1719C4.4165 16.1875 11.6353 8.78125 20.604 8.75C22.7432 8.74177 24.863 9.15602 26.8418 9.96897C28.8206 10.7819 30.6193 11.9776 32.1349 13.4874C33.6505 14.9971 34.8531 16.7913 35.6736 18.7669C36.4941 20.7425 36.9165 22.8607 36.9165 25V28.75C36.9165 29.0815 36.7848 29.3995 36.5504 29.6339C36.316 29.8683 35.998 30 35.6665 30H5.6665C5.33498 30 5.01704 29.8683 4.78262 29.6339C4.5482 29.3995 4.4165 29.0815 4.4165 28.75Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 8.75V13.75",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96338 20.7969L9.80713 22.0937",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3696 20.7969L31.5259 22.0937",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8228 30L27.5103 16.0781",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/Gauge.0b465570f69b0593007c195214fdb8c6.svg";
export { ForwardRef as ReactComponent };